// extracted by mini-css-extract-plugin
export default {"cardStructure":"CardStructure_cardStructure__LF2C8"};